import { Component, inject } from '@angular/core';
import { ClevertapService } from '../../../service/clevertap.service';
import { CarInsuranceNavbarComponent } from '../car-insurance-navbar/car-insurance-navbar.component';
import { CarInsuranceBannerComponent } from '../car-insurance-banner/car-insurance-banner.component';
import { CarInsuranceFooterComponent } from '../car-insurance-footer/car-insurance-footer.component';
import { CarInsuranceProductComponent } from '../car-insurance-product/car-insurance-product.component';
import { CarInsuranceWhytochooseComponent } from '../car-insurance-whytochoose/car-insurance-whytochoose.component';
import { CarInsuranceWhyyouneedComponent } from '../car-insurance-whyyouneed/car-insurance-whyyouneed.component';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-car-insurance-home',
  standalone: true,
  imports: [CarInsuranceNavbarComponent, CommonModule, RouterModule, CarInsuranceBannerComponent, CarInsuranceWhytochooseComponent, CarInsuranceWhyyouneedComponent, CarInsuranceProductComponent, CarInsuranceFooterComponent],
  templateUrl: './car-insurance-home.component.html',
  styleUrl: './car-insurance-home.component.scss'
})
export class CarInsuranceHomeComponent {
  source: string | null = null;
  clevertapService = inject(ClevertapService)
  showLayout = true;
  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showLayout = !event.url.includes('/success');
      });
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.source = params.get('source');
    });
    const productType = 'car_insurance';
    const trafficSource = this.source;
    this.clevertapService.clearStorage();
    this.clevertapService.trackEvent('visited_product_landing_page', {
      traffic_source: trafficSource,
      product_type: productType
    });
  }
}
